import type { EditorJsonContent } from '../app/contexts/ContentInterfaces';

export const validateConfig = (config?: EditorJsonContent) => {
  if (config && typeof config === 'object') {
    return typeof config.theme === 'string' && Array.isArray(config.gallery);
  }
  return false;
};
